import request from '../../helpers/request';

const licenseRequest = () => {
    return { type: 'LICENSE_REQUEST' };
};

const licenseSuccess = licenses => {
    return { type: 'LICENSE_SUCCESS', licenses };
};

const licenseFailure = error => {
    return {
        type: 'LICENSE_FAILURE',
        error
    };
};

const license = () => async dispatch => {
    try {
        dispatch(licenseRequest());

        const response = await request({
            method: 'get',
            url: '/hamyar-api/v1/sites'
        });

        dispatch(licenseSuccess(response.data));

        return Promise.resolve(response.data);
    } catch (error) {
        dispatch(licenseFailure(error));
    }
};

export { licenseRequest, licenseSuccess, licenseFailure, license };
